import * as dialog from 'plugins/dialog';
import * as router from 'plugins/router';

import * as companyService from '@/legacy/services/company';

class BillingDebitFailedModal {
  view = 'features/companies/serviceSubscriptions/modals/billingDebitFailedModal';

  /* Because SelectCompany can be called multiple times (ex: during invitation) we want to ensure we
  never show more than 1 of these modals */
  public static isVisible = false;

  public companyService = companyService.Instance;

  public Close(): void {
    BillingDebitFailedModal.isVisible = false;
    dialog.close(this, false);
  }

  public Continue(): void {
    BillingDebitFailedModal.isVisible = false;
    dialog.close(this, true);
    router.navigate('user/settings/billing');
  }

  public static show(): JQueryPromise<boolean> {
    if (BillingDebitFailedModal.isVisible) {
      return;
    }

    BillingDebitFailedModal.isVisible = true;
    dialog.show(new BillingDebitFailedModal());
  }
}

export default BillingDebitFailedModal;
